{
  "salon-booking-config-page": {
    "buttons": {
      "book": "BOOK"
    },
    "text": {
      "black-listed": "Your online booking option at this salon is blocked. Please contact the salon to book a new appointment",
      "not-found-available-time": "If you can not find the desired time, please call us at the phone number"
    }
  }
}
